import snarkdown from 'snarkdown'

/**
 * Parse markdown to HTML.
 */
export const parseMarkdown = (text: string) => {
  return snarkdown(text)
}
